module.exports = __webpack_public_path__ + "static/img/20230428_04.2632f58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230428_04.png
// module id = OD8+
// module chunks = 0